import { render, staticRenderFns } from "./BirthdaysAll.vue?vue&type=template&id=6e08c7b0&scoped=true&"
import script from "./BirthdaysAll.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08c7b0",
  null
  
)

export default component.exports